import ScentsSection from './ScentsSection';

export default ScentsSection;
